import Vivus from "vivus";

const init = () => {
    let $preloader = $('.preloader');
    let $graph = $preloader.find('.graph');

    gsap.timeline().from([$graph.find('.step-1'),$graph.find('.step-2')], 0.5, {
        opacity: 0,
        onStart: () => {
            $graph.removeClass('is-hidden');
        }
    }).from([$graph.find('.step-3'),$graph.find('.step-4')], 0.5, {
        opacity: 0,
    }).from([$graph.find('.step-5'),$graph.find('.step-6')], 0.5, {
        opacity: 0,
    }).from([$graph.find('.step-7'),$graph.find('.step-8'),$graph.find('.step-9'), $preloader.find('.preloader__text')], 0.5, {
        opacity: 0,
        onComplete: () => {
            gsap.timeline().to([$graph, $preloader.find('.preloader__text')], 1, {
                opacity: 0,
            }).to($preloader, 0.7, {
                yPercent: -100,
            });
        }
    })
};

export default {
    init
}
